export default __webpack_public_path__ + "4ef4a86.png";